const ITEMS = [
  "Daily Gratitude",
  "Intentional Living",
  "Mindful Mornings",
  "Sacred Reflection",
  "Love the Life You Live",
  "120 Guided Pages",
  "Embrace Every Season",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-xl italic text-sienna/80 sm:text-2xl">
          {item}
        </span>
        <span className="text-sm text-terracotta/70">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="marquee-ribbon"
    className="relative overflow-hidden border-y border-terracotta/10 bg-[#FAF1EE] py-5"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
